import { stats } from '@fiverr-private/obs';
import { PREFIX } from './constants';

/**
 * Increments the given stats counter by 1 via window function or obs.
 * @param {String} metric - key to send to stats
 */
const increment = (metric) => {
    if (typeof Fiverr === 'object' && typeof Fiverr._logEventToGraphite === 'function') {
        Fiverr._logEventToGraphite({
            label: `${PREFIX}.${metric}`,
            percentage: 100
        });
    } else {
        stats.count(PREFIX, metric);
    }
};

/**
 * Reports given timing metric to stats via window function or obs.
 * @param {String} metric - key to send to stats timing
 * @param {Number} startTime - start measuring
 */
const time = (metric, startTime) => {
    const value = Date.now() - startTime;

    if (typeof Fiverr === 'object' && typeof Fiverr._broadcastLogEvents === 'function') {
        Fiverr._broadcastLogEvents({
            facility: 'graphite',
            type: 'timing',
            label: `${PREFIX}.${metric}`,
            value
        });
    } else {
        stats.time(PREFIX, metric, value);
    }
};

export {
    increment,
    time
};
